import React, { useMemo } from 'react';
import { AdminModalController } from '../admin-modal-controller';
import { AdminPanelContainer } from '../admin-panel-container';
import { AdminPanelController } from '../admin-panel-controller';
import { AdminShellProps } from './admin-shell-props';
import { AdminSiteViewport } from '../admin-site-viewport';
import { Redirect } from 'react-router-dom';
import WindowMessenger from '@robotsnacks/window-messenger';
import { isLoggedIn } from '../../../selectors';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
  position: relative;
  width: 100vw;
`;

const Main = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
  order: 2;
  position: relative;
  z-index: 2;
`;

export const AdminShell: React.FunctionComponent<
  AdminShellProps
> = (): React.ReactElement => {
  const loggedIn = useSelector(isLoggedIn);

  if (!loggedIn) {
    return <Redirect to="/admin/login" />;
  }

  const messenger = useMemo(
    () =>
      new WindowMessenger({
        allowedOrigins: /.*/,
        target: () =>
          document.getElementsByTagName('iframe')[0].contentWindow as any,
      }),
    [],
  );

  return (
    <Wrapper>
      <Main>
        <AdminSiteViewport style={{ flex: 1, zIndex: 2 }} />
      </Main>
      <AdminPanelContainer>
        <AdminPanelController />
      </AdminPanelContainer>
      <AdminModalController />
    </Wrapper>
  );
};

AdminShell.displayName = 'AdminShell';
